// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Account__ColorController from "./account/color_controller"
application.register("account--color", Account__ColorController)

import Account__FirmController from "./account/firm_controller"
application.register("account--firm", Account__FirmController)

import Account__FontsController from "./account/fonts_controller"
application.register("account--fonts", Account__FontsController)

import Account__UserRoleController from "./account/user_role_controller"
application.register("account--user-role", Account__UserRoleController)

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import ChartLoaderController from "./chart_loader_controller"
application.register("chart-loader", ChartLoaderController)

import Editor__AddElementController from "./editor/add_element_controller"
application.register("editor--add-element", Editor__AddElementController)

import Editor__CustomCssController from "./editor/custom_css_controller"
application.register("editor--custom-css", Editor__CustomCssController)

import Editor__ElementSelectionController from "./editor/element_selection_controller"
application.register("editor--element-selection", Editor__ElementSelectionController)

import Editor__FormsSharedController from "./editor/forms_shared_controller"
application.register("editor--forms-shared", Editor__FormsSharedController)

import Editor__ImageFormController from "./editor/image_form_controller"
application.register("editor--image-form", Editor__ImageFormController)

import Editor__LayoutEventListenersController from "./editor/layout_event_listeners_controller"
application.register("editor--layout-event-listeners", Editor__LayoutEventListenersController)

import Editor__LiquidController from "./editor/liquid_controller"
application.register("editor--liquid", Editor__LiquidController)

import Editor__MultiInapp__LinesController from "./editor/multi_inapp/lines_controller"
application.register("editor--multi-inapp--lines", Editor__MultiInapp__LinesController)

import Editor__MultiInapp__SortableButtonsController from "./editor/multi_inapp/sortable_buttons_controller"
application.register("editor--multi-inapp--sortable-buttons", Editor__MultiInapp__SortableButtonsController)

import Editor__MultiSlider__EventsController from "./editor/multi_slider/events_controller"
application.register("editor--multi-slider--events", Editor__MultiSlider__EventsController)

import Editor__MultiSlider__InappsController from "./editor/multi_slider/inapps_controller"
application.register("editor--multi-slider--inapps", Editor__MultiSlider__InappsController)

import Editor__MultiSlider__ReorderController from "./editor/multi_slider/reorder_controller"
application.register("editor--multi-slider--reorder", Editor__MultiSlider__ReorderController)

import Editor__MultiSlider__UniversalStyleFormController from "./editor/multi_slider/universal_style_form_controller"
application.register("editor--multi-slider--universal-style-form", Editor__MultiSlider__UniversalStyleFormController)

import Editor__MultipleSelectOptionsController from "./editor/multiple_select_options_controller"
application.register("editor--multiple-select-options", Editor__MultipleSelectOptionsController)

import Editor__NameSectionController from "./editor/name_section_controller"
application.register("editor--name-section", Editor__NameSectionController)

import Editor__OrderElementsController from "./editor/order_elements_controller"
application.register("editor--order-elements", Editor__OrderElementsController)

import Editor__TemplatesController from "./editor/templates_controller"
application.register("editor--templates", Editor__TemplatesController)

import Editor__ToggleDarkModeController from "./editor/toggle_dark_mode_controller"
application.register("editor--toggle-dark-mode", Editor__ToggleDarkModeController)

import Editor__ZoomController from "./editor/zoom_controller"
application.register("editor--zoom", Editor__ZoomController)

import InappPartialController from "./inapp_partial_controller"
application.register("inapp-partial", InappPartialController)

import IntercomController from "./intercom_controller"
application.register("intercom", IntercomController)

import Library__NewProjectController from "./library/new_project_controller"
application.register("library--new-project", Library__NewProjectController)


import PreviewLiquidController from "./preview_liquid_controller"
application.register("preview-liquid", PreviewLiquidController)

import RegistrationController from "./registration_controller"
application.register("registration", RegistrationController)

import Shared__ConfirmationController from "./shared/confirmation_controller"
application.register("shared--confirmation", Shared__ConfirmationController)

import Shared__DisplayController from "./shared/display_controller"
application.register("shared--display", Shared__DisplayController)

import Shared__DropdownController from "./shared/dropdown_controller"
application.register("shared--dropdown", Shared__DropdownController)

import Shared__FlashController from "./shared/flash_controller"
application.register("shared--flash", Shared__FlashController)

import Shared__FormController from "./shared/form_controller"
application.register("shared--form", Shared__FormController)

import Shared__ImagePreviewController from "./shared/image_preview_controller"
application.register("shared--image-preview", Shared__ImagePreviewController)

import Shared__JsFlashController from "./shared/js_flash_controller"
application.register("shared--js-flash", Shared__JsFlashController)

import Shared__MobileMenuController from "./shared/mobile_menu_controller"
application.register("shared--mobile-menu", Shared__MobileMenuController)

import Shared__ModalController from "./shared/modal_controller"
application.register("shared--modal", Shared__ModalController)
